module.exports = __webpack_public_path__ + "img/icon_trade_usage_static.83c792b.svg";